import React from 'react';

const ProgramBookImportPage = React.lazy(() => import('../pages/programs/ProgramBookImportPage/ProgramBookImportPage'));
const ProgramCreatePage = React.lazy(() => import('../pages/programs/ProgramCreatePage/ProgramCreatePage'));
const ProgramDetailPage = React.lazy(() => import('../pages/programs/ProgramDetailPage/ProgramDetailPage'));
const ProgramsPage = React.lazy(() => import('../pages/programs/ProgramsPage/ProgramsPage'));
const ProgramMintStandAlone = React.lazy(() => import('../pages/programs/ProgramMintStandAlone/ProgramMintStandAlone'));
const ProgramDistributionEditorPage = React.lazy(() => import('../pages/programs/ProgramDistributionEditorPage/ProgramDistributionEditorPage'));

export const PATH_PROGRAM = '/program/:guid';
export const PATH_PROGRAM_BOOK_IMPORT = '/program/:guid/book-import';
export const PATH_PROGRAM_STEP = '/program/:guid/:step?';
export const PATH_PROGRAMS = '/programs';
export const PATH_PROGRAM_CREATE = '/program/create';
export const PATH_PROGRAM_MINT_STAND_ALONE = '/program/mint-stand-alone/:guid/:role';
export const PATH_PROGRAM_DISTRIBUTION_EDITOR = '/program/:guid/distributions/:distributionId/editor';

const PAGE_PROGRAM = {
  component: ProgramDetailPage,
  path: PATH_PROGRAM,
};

const PAGE_PROGRAM_BOOK_IMPORT = {
  component: ProgramBookImportPage,
  path: PATH_PROGRAM_BOOK_IMPORT,
};

const PAGE_PROGRAM_STEP = {
  component: ProgramDetailPage,
  path: PATH_PROGRAM_STEP,
};

const PAGE_PROGRAMS = {
  component: ProgramsPage,
  path: PATH_PROGRAMS,
};

const PAGE_PROGRAM_CREATE = {
  component: ProgramCreatePage,
  path: PATH_PROGRAM_CREATE,
};

const PAGE_PROGRAM_MINT_STAND_ALONE = {
  component: ProgramMintStandAlone,
  path: PATH_PROGRAM_MINT_STAND_ALONE,
};

const PAGE_PROGRAM_DISTRIBUTION_EDITOR = {
  component: ProgramDistributionEditorPage,
  path: PATH_PROGRAM_DISTRIBUTION_EDITOR,
};

// IMPORTANT: The order in which the pages are added is important
// PAGE_PROGRAM_BOOK_IMPORT va antes de PAGE_PROGRAM_STEP: '/program/:guid/:step?' también casa con
// '/program/:guid/book-import' y se quedaría la ruta sin renderizar.
export default [
  PAGE_PROGRAMS,
  PAGE_PROGRAM_CREATE,
  PAGE_PROGRAM_MINT_STAND_ALONE,
  PAGE_PROGRAM_DISTRIBUTION_EDITOR,
  PAGE_PROGRAM_BOOK_IMPORT,
  PAGE_PROGRAM_STEP,
  PAGE_PROGRAM,
];
